import './FindDuplicateProperties.scss';
import Component from './FindDuplicateProperties.js';
export default Component;
